import React from 'react';
import { TextField } from '@material-ui/core';

const styles = {
    textField : {
        margin: 20
    }
}

export default function SearchByInvoice(props) {
    const invoiceNumberOnChange = (e) => {
        props.setInvoiceId(e.target.value);
    }
    
    return (
        <div>
            <TextField
                style={styles.textField}
                label="Invoice Number"
                id='invoiceNumber'
                onChange={e => invoiceNumberOnChange(e)}
            />
        </div>
    );

}